import { MEDIAS_LIST } from '@/common/js/constants.js'
import { toPercentFixed, toThousands } from '@/common/js/filters'
import { isArray, isEmpty } from '@/common/js/utils'
import moment from 'moment'

export function useTableHelpers() {
  const getMediaName = (media) => {
    return MEDIAS_LIST.find((item) => item.value === media)?.label || '-'
  }

  const getDateRange = () => {
    const startDate = moment().subtract(6, 'days').format('YYYY-MM-DD')
    const endDate = moment().format('YYYY-MM-DD')
    return [startDate, endDate]
  }

  const statusClass = (id) => {
    let cls = ''
    switch (id) {
      case 1:
        cls = 'tag-success'
        break
      case 2:
        cls = 'tag-warn'
        break
      case 5:
        cls = 'tag-error'
        break
      default:
        cls = 'tag-disabled'
        break
    }
    return cls
  }

  const sumColumn = (text) => text !== undefined

  const rowValueFmt = (val) => {
    if (val === null) return '-'
    if (val === 0) return '不限'
    else return val
  }

  const rowBidValueFmt = (val) => {
    if (val > 0) return val
    return '-'
  }

  const roiFmt = (val) => {
    if (val === null) return 0
    else if (typeof val === 'string' || typeof val === 'number') return val
    else return 0
  }

  const getPercentValue = (key) => {
    if (['deductRate'].includes(key)) return false
    if (['firstDayRoi', 'threeDayRoi', 'sevenDayRoi', 'createRole24hRoi', 'createRole24hAdjustedRoi', 'mDay1RoleRoi',
      'monetizationRoi24h', 'monetizationRoi3d', 'monetizationRoi7d'].includes(key)) {
      return true
    }
    return key.indexOf('Rate') > -1 || key.indexOf('Retain') > -1
  }

  const toThousandKeys = (key) => {
    return [
      'pv',
      'clickNum',
      'paperUseAmount',
      'giveAmount',
      'amount',
      'newRoleMoney',
      'newDeviceMoney',
      'sumMoney',
      'collectClickNum',
      'monetizationAmount24h',
      'monetizationAmount3d',
      'monetizationAmount7d'
    ].includes(key)
  }

  return {
    getMediaName,
    getDateRange,
    statusClass,
    sumColumn,
    rowValueFmt,
    rowBidValueFmt,
    roiFmt,
    getPercentValue,
    toThousandKeys,
    isEmpty,
    isArray,
    toPercentFixed,
    toThousands
  }
}
